<template>
  <div class="rewards" >
    <div
        class="reward"
        :class="reward.left ? 'active' : 'inactive' "
        v-for="reward in data"
        :key="reward.id"
      >
      <div class="reward__header">
        <h3 class="reward__name">{{reward.name}}</h3>
        <h4 class="reward__title">{{reward.title}}</h4>
      </div>
      <p class="reward__description">{{reward.text}}</p>
      <div class="reward__left">
        <span class="number">{{reward.left}}</span> left
      </div>
      <div class="reward__cta">
        <Button
          :value="!!reward.left ? reward.action : 'Out of Stock'"
          :disabled="!reward.left"
          :click="toggle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from './reusable/Button.vue';

export default {
  name: 'Rewards',
  components: {
    Button,
  },
  props: {
    data: Array,
    toggleBackproject: Function,
  },
  methods: {
    toggle() {
      this.$emit('backtoggle');
      return 'clicked';
    },
  },
};
</script>

<style lang="scss" scoped>
.rewards {
  .inactive {
    opacity: 0.5;
  }
}

.reward {
  padding: calc(var(--sm-spacer) / 2);
  box-shadow: 0 0 1px 0 var(--dark-gray);
  border-radius: var(--border-radius);

  + .reward {
    margin-top: var(--sm-spacer);
  }

  &__name {
    font-size: var(--fs-h5);
  }

  &__header, &__description, &__cta, &__left {
    margin-bottom: calc(var(--sm-spacer) / 2);
  }

  &__title {
    color: var(--moderate-cyan);
    font-size: var(--fs-h5);
    font-weight: 500;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: calc(var(--sm-spacer) / 5);
    .number {
      font-size: var(--fs-h3);
      font-weight: 700;
    }
  }

  &__cta {
    .button:disabled {
      background: var(--black);
    }
  }
}
</style>
